$(function() {
    $('.autopilot-email-list-unsub-all').on('click', function() {
        const $this = $(this);
        if ($this.is(':checked')) {
            $('.autopilot-email-list').removeAttr('checked').trigger('change');
        }
    });

    $('.autopilot-email-list').on('click', function() {
        const unsubEl = $('.autopilot-email-list-unsub-all');
        if (unsubEl.is(':checked')) {
            unsubEl.removeAttr('checked').trigger('change');
        }
    });
});



// WEBPACK FOOTER //
// ./js/modules/emailSubscriptionPage.js